<template>
  <div id="constitution">
    <div v-html="content"></div>
  </div>
</template>

<script>
import {reContent} from '@/assets/utility'

export default {
  data() {
    return {
      content: ''
    }
  },
  mounted() {
    this.$store.commit('setAboutTabI', 1)
    this.$axios.post('about/getConstitution').then((res)=>{
      if (res) {
        this.content= reContent(res.content)
      }
    })
  }
}
</script>
